import breakdownImage from "../../../../../src/images/chonky-breakdown.jpg";
import * as React from 'react';
export default {
  breakdownImage,
  React
};